import REQUIRED_FIELDS from '@/pages/projects/REQUIRED_FIELDS';
import usePagedQuery from '@/hooks/usePagedQuery';
import { STUDENT_IMPACT_MESSAGE, sumActualStudents } from '@/utils/studentImpact';

export default function useProjectStudentImpact(network, schoolStart, schoolEnd) {
  const projects = usePagedQuery('projects', {
    where: {
      eager: {
        $where: {
          $and: REQUIRED_FIELDS.$and,
          networkId: network?.id,
          completed: true,
          createdAt: {
            $lte: schoolEnd,
            $gte: schoolStart
          }
        }
      }
    }
  }, { source: 'dashboard-year/useProjectStudentImpact', message: STUDENT_IMPACT_MESSAGE });

  const totalCount = sumActualStudents(projects.data);

  return [
    projects,
    totalCount
  ];
}
